import { render, staticRenderFns } from "./full-route-city-list.vue?vue&type=template&id=53db196a&"
import script from "./full-route-city-list.vue?vue&type=script&lang=ts&"
export * from "./full-route-city-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports